<template minapp='mpx' xlang='wxml'>
  <from-item isShow="{{isShow}}" 
    isRequired="{{isRequired}}" 
    isRequiredShow="{{isRequiredShow}}" 
    label="出生日期" 
    innerValue="{{innerValue}}"
    isDisable="{{isBorndateDisable}}"
  >
    <view slot="input" class="es-content__birth-data-input">
      <view style="flex:1">
        <picker mode="date" value="{{innerValue}}" start="1900-01-01" end="{{endDate}}" bindchange="bindDateChange">
          <view class="picker">
            <view wx:if="{{innerValue !== ''}}">{{formatBirthData(innerValue)}}</view>
            <view wx:else class="placeholder">与证件日期保持一致</view>
          </view>
        </picker>
      </view>
      <es-icon name='angle-right' size="16" color="#999999"></es-icon>
    </view>
  </from-item>
</template>

<script>
import { watch } from "@mpxjs/core";

  import { createComponent } from '@didi/es-mpx-creator'
  import { formatDate } from '@didi/es-mpx-shared'
  import { hasRequired } from '@/utils'
  createComponent({
    classes: [],
    data: {
      innerValue:''
    },
    props: {
      value:{
        type: String,
        value: ''
      },
      isRequiredShow: {
        type: Boolean,
        value: false
      },
      isShow: {
        type: Boolean,
        value: false
      },
      endDate: {
        type: String,
        value: formatDate(),
      },
      item:Object,
      selectedCardList:Array,
      isNeedCard:Boolean,
      isBorndateDisable: Boolean
    },
    computed: {
      isRequired() {
        return hasRequired(this.item?.requiredcCrdTypes,this.selectedCardList,this.item?.isRequired,this.isNeedCard)
      }
    },
    methods: {
      // 选择出生日期
      bindDateChange(e) {
        this.innerValue = e.detail.value
      },
      formatBirthData(key = '') {
        if(key?.length > 8) return key
        let year = key?.substring?.(0, 4)
        let month = key?.substring?.(4, 6)
        let day = key?.substring?.(6, 8)
        return `${year}-${month}-${day}`
      }
    },
    watch:{
      value(val) {
        this.innerValue = this.formatBirthData(val)
      },
      //将数据回传
      innerValue(newValue) {
        this.$trigger( 'input', {value:newValue} )
      },
    },
    mounted() {
      this.innerValue = this.value
    }
  })
</script>

<style lang='stylus' scoped>
+b('content')
  +e('birth-data-input')
    display flex
    width 100%
    justify-content space-between
    align-items center
.placeholder{
  color #999999
}
</style>

<script name='json'>
  module.exports = {
    component: true,
    "usingComponents": {
      'es-icon': '@didi/es-mpx-ui/lib/icon',
      'es-cell': '@didi/es-mpx-ui/lib/cell',
      'es-field': '@didi/es-mpx-ui/lib/field',
      'from-item': './from-item'
    }
  }
</script>

